import { action } from 'nanostores'
import { $discountOptionWeeks, $discountOptions, $promises } from './stores'

export const setDiscountOption = action(
  $discountOptions,
  'setDiscountOption',
  (store, { discountOptionId, discountOption }) => {
    store.setKey(discountOptionId, discountOption)
  },
)

export const setDiscountOptionWeeks = action(
  $discountOptionWeeks,
  'setDiscountOptionWeeks',
  (store, { subscriptionId, discountOptionWeeks }) => {
    store.setKey(subscriptionId, discountOptionWeeks)
  },
)

export const setPromise = action(
  $promises,
  'setPromise',
  (store, { promiseKey, promise }) => {
    store.setKey(promiseKey, promise)
  },
)
export const clearPromises = action($promises, 'clearPromises', (store) => {
  store.set({})
})
